export var ChainType;
(function (ChainType) {
    ChainType["EVM"] = "EVM";
    // Solana virtual machine
    ChainType["SVM"] = "SVM";
    // Move virtual machine
    ChainType["MVM"] = "MVM";
    // Unspent transaction output (e.g. Bitcoin)
    ChainType["UTXO"] = "UTXO";
    // Tron virtual machine
    ChainType["TVM"] = "TVM";
})(ChainType || (ChainType = {}));
//# sourceMappingURL=Chain.js.map